module.exports = __webpack_public_path__ + "img/long_term_goal.97cb22a3.svg";